import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {Berth, FindTerminals, Municipality, Terminal} from '@portbase/bezoekschip-service-typescriptmodels';
import {sendQuery} from '../../common/utils';
import {map} from "rxjs/operators";

@Component({
    selector: 'app-edit-berth',
    templateUrl: './edit-berth.component.html',
    styleUrls: ['./edit-berth.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditBerthComponent {
  @Input() berth: Berth;
  portsOfCall = sendQuery('com.portbase.bezoekschip.common.api.visit.GetPcsPorts', {}).pipe(map(ports => ports.map(p => p.port.locationUnCode)));
  allMunicipalities: Municipality[] = [
    {code: "NLABL", name: "Alblasserdam"},
    {code: "NLDOR", name: "Dordrecht"},
    {code: "NLGDR", name: "Goedereede"},
    {code: "NLGOR", name: "Gorinchem"},
    {code: "NLHXG", name: "Hardinxveld-Giessendam"},
    {code: "NLMSL", name: "Maassluis"},
    {code: "NLMOE", name: "Moerdijk"},
    {code: "NLNIJ", name: "Nijmegen"},
    {code: "NLPAP", name: "Papendrecht"},
    {code: "NLRTM", name: "Rotterdam"},
    {code: "NLSCI", name: "Schiedam"},
    {code: "NLSLD", name: "Sliedrecht"},
    {code: "NLSTD", name: "Stellendam"},
    {code: "NLVLA", name: "Vlaardingen"},
    {code: "NLZWI", name: "Zwijndrecht"}
  ]

  get municipalityUnlocodes(): string[] {
    return this.allMunicipalities.map(m => m.code);
  }

  formatMunicipality = (code: string) => this.allMunicipalities.find(m => m.code == code).name;

  searchTerminal = (term, portUnCode) => sendQuery('com.portbase.bezoekschip.common.api.visit.FindTerminals',
    <FindTerminals>{term: term, portUnCode: portUnCode});
  terminalFormatter = (terminal: Terminal) => terminal && terminal.terminalCode ? terminal.terminalCode + ' - ' + terminal.terminalName : "";

  setTerminal(terminal: Terminal) {
    if (!terminal) {
      this.berth.terminalCode = null;
      this.berth.terminalName = null;
      this.berth.organisationName = null;
      this.berth.organisationShortName = null;
    } else {
      this.berth.terminalCode = terminal.terminalCode;
      this.berth.terminalName = terminal.terminalName;
      this.berth.organisationName = terminal.organisationName;
      this.berth.organisationShortName = terminal.organisationShortName;
    }
  }

  inPortOfRotterdam() : boolean {
    return this.berth.portCode == "NLRTM"
  }

  setBollards($event, start) {
    if (!$event) {
      this.berth.bollards = null;
    } else {
      if (!this.berth.bollards) {
        this.berth.bollards = <any>{};
      }
      start ? this.berth.bollards.start = $event : this.berth.bollards.end = $event;
    }
  }
}
